import { render } from "./CoBrandPulse.vue?vue&type=template&id=9d00a7c6&scoped=true"
import script from "./CoBrandPulse.vue?vue&type=script&lang=js"
export * from "./CoBrandPulse.vue?vue&type=script&lang=js"

import "./CoBrandPulse.vue?vue&type=style&index=0&id=9d00a7c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d00a7c6"]])

export default __exports__